import { render } from "./ProductCategoryTable.vue?vue&type=template&id=12c1c70e"
import script from "./ProductCategoryTable.vue?vue&type=script&lang=js"
export * from "./ProductCategoryTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__